/** Resize a composed photo blob for 58mm thermal (384 dots wide). */
export async function exportThermalImageBlob(source: Blob): Promise<Blob> {
  const THERMAL_WIDTH = 384
  const MAX_HEIGHT = 2000
  const JPEG_QUALITY = 0.85

  const bitmap = await createImageBitmap(source)
  const srcWidth = bitmap.width
  const srcHeight = bitmap.height
  const targetWidth = Math.min(THERMAL_WIDTH, srcWidth)
  let targetHeight = Math.round((srcHeight * targetWidth) / srcWidth)
  if (targetHeight > MAX_HEIGHT) targetHeight = MAX_HEIGHT

  const canvas = document.createElement('canvas')
  canvas.width = targetWidth
  canvas.height = targetHeight
  const ctx = canvas.getContext('2d')
  if (!ctx) throw new Error('Canvas not available')
  ctx.drawImage(bitmap, 0, 0, targetWidth, targetHeight)
  bitmap.close()

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (blob) resolve(blob)
        else reject(new Error('Failed to encode thermal image'))
      },
      'image/jpeg',
      JPEG_QUALITY
    )
  })
}

export async function blobToBase64DataUrl(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result as string)
    reader.onerror = () => reject(reader.error ?? new Error('read failed'))
    reader.readAsDataURL(blob)
  })
}
